// Template249: Bélgica - Día 2 Amberes (Page6.jsx)
// Hero portada + título Amberes + sticker, intro, Estación Central, tip Barrio Diamantes, Grote Markt, Catedral, Casa de Rubens.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template249 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const estacionTitle = page?.texts?.[2]?.content;
	const estacionBody = page?.texts?.[3]?.content;
	const tipDiamantes = page?.texts?.[4]?.content;
	const groteTitle = page?.texts?.[5]?.content;
	const groteBody = page?.texts?.[6]?.content;
	const catedralTitle = page?.texts?.[7]?.content;
	const catedralBody = page?.texts?.[8]?.content;
	const rubensTitle = page?.texts?.[9]?.content;
	const rubensBody = page?.texts?.[10]?.content;
	const linkCatedral = page?.data?.linkCatedral;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const imgEstacion = getImageSrc("img2");
	const img1 = getImageSrc("img1");
	const img2Sticker = getImageSrc("img2-sticker");
	const img3 = getImageSrc("img3");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#000",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Hero */}
			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				<Box
					component="h1"
					sx={{
						fontSize: isSmallScreen ? 28 : 32,
						textAlign: "center",
						position: "absolute",
						bottom: 0,
						margin: "10px",
						left: 20,
						color: "#fff",
						textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						fontWeight: 700,
					}}
				>
					Amberes
				</Box>
				{portadaSticker && (
					<Box
						component="img"
						src={portadaSticker}
						alt=""
						sx={{ width: 90, position: "absolute", bottom: 60, left: 20 }}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box
						component="p"
						sx={{ fontSize: 13, color: "#333", margin: 0, padding: 0 }}
					>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: "10px",
						position: "relative",
					}}
				>
					{/* Estación Central */}
					{(estacionTitle || estacionBody) && (
						<Box data-block-id="text-3" sx={{ width: "100%" }}>
							<Box
								sx={{
									padding: "16px",
									backgroundColor: "#f9ebc8",
									borderRadius: "12px",
									fontSize: 13,
									color: "#000",
								}}
							>
								{imgEstacion && (
									<Box
										component="img"
										src={imgEstacion}
										alt="Estación"
										style={{
											width: 105,
											float: "right",
											marginRight: -34,
											marginTop: -25,
										}}
									/>
								)}
								{estacionTitle && (
									<Box component="h3" sx={estiloH3}>
										{estacionTitle}
									</Box>
								)}
								{estacionBody && <Box component="span">{estacionBody}</Box>}
							</Box>
						</Box>
					)}

					{/* Grote Markt */}
					{(groteTitle || groteBody) && (
						<Box
							data-block-id="text-4"
							sx={{
								display: "flex",
								gap: 2,
								marginBottom: isSmallScreen ? "50px" : 0,
								position: "relative",
							}}
						>
							{tipDiamantes && (
								<Box
									sx={{
										position: "absolute",
										top: isSmallScreen ? 160 : -20,
										left: isSmallScreen ? 70 : 4,
										backgroundColor: "#fff8db",
										border: "2px solid #D4A017",
										borderRadius: "16px 16px 16px 0px",
										padding: "10px 12px",
										fontSize: "11px",
										color: "#444",
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: isSmallScreen ? 220 : 120,
										zIndex: 6,
									}}
									dangerouslySetInnerHTML={{ __html: tipDiamantes }}
								/>
							)}
							{img2Sticker && (
								<Box
									component="img"
									src={img2Sticker}
									alt=""
									sx={{
										width: 100,
										position: "absolute",
										top: isSmallScreen ? 130 : 30,
										left: isSmallScreen ? -20 : -40,
										zIndex: 5,
									}}
								/>
							)}

							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							<Box sx={{ width: "60%" }}>
								{groteTitle && (
									<Box component="h3" sx={estiloH3}>
										{groteTitle}
									</Box>
								)}
								{groteBody && (
									<Box
										component="p"
										sx={{ fontSize: 13, color: "#444", marginTop: "0px" }}
									>
										{groteBody}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Catedral */}
					{(catedralTitle || catedralBody) && (
						<Box data-block-id="text-5" sx={{ width: "100%", marginTop: isSmallScreen ? 2 : 0 }}>
							<Box
								sx={{
									padding: "12px",
									backgroundColor: "#f9ebc8",
									borderRadius: "12px",
									fontSize: 13,
									color: "#000",
								}}
							>
								{catedralTitle && (
									<Box component="h3" sx={estiloH3}>
										{catedralTitle}
									</Box>
								)}
								{catedralBody && (
									<Box
										component="span"
										dangerouslySetInnerHTML={{ __html: catedralBody }}
									/>
								)}
							</Box>
						</Box>
					)}

					{/* Casa de Rubens */}
					<Box data-block-id="text-6" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{sabiasQue[0] && (
							<Box sx={{ position: "absolute", top: -10, left: "32%" }}>
								<SabiasQue
									icono={sabiasQue[0].icono}
									texto={sabiasQue[0].texto}
								/>
							</Box>
						)}
						{sabiasQue[1] && (
							<Box sx={{ position: "absolute", top: 32, left: "32%" }}>
								<SabiasQue
									icono={sabiasQue[1].icono}
									texto={sabiasQue[1].texto}
								/>
							</Box>
						)}
						{img3 && (
							<Box
								component="img"
								src={img3}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						<Box sx={{ width: "60%", position: "relative" }}>
							{rubensTitle && (
								<Box component="h3" sx={estiloH3}>
									{rubensTitle}
								</Box>
							)}
							{rubensBody && (
								<Box component="p" sx={estiloP}>
									{rubensBody}
								</Box>
							)}
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template249.thumbnail = "/images/template-1.png";
export default Template249;
